//pagetop
$(function(){
	var topBtn = $('#pageTop');
	topBtn.hide();
	$(window).scroll(function(){
	  if($(this).scrollTop()>300){
	    topBtn.fadeIn();
	  }else{
	    topBtn.fadeOut();
	  }
	});
});

//orderflow
$(function(){
	$('.orderflowAcTitle,.orderflow2AcTitle').on('click',function(){
		$(this).toggleClass('on');
	});
});

//drawerCart
$(document).ready(function () {

  $(document).on('cartItemAdded', function () {
    updateCartTotalText();
  });

  setInterval(updateCartTotalText, 2500);

  updateCartTotalText();
});
function updateCartTotalText() {

  var currentCartTotal = parseFloat($('#drawerCartTotalPrice').text().replace('¥', '').replace(',', ''));

  var freeShippingThreshold = 15000;
  var remainingAmount = freeShippingThreshold - currentCartTotal;

  var text = '';
  if (remainingAmount > 0) {
    text = 'あと <span class="drawerCartTotalPriceText1">¥' + remainingAmount.toLocaleString() + '</span> で <span class="drawerCartTotalPriceText2">送料無料！！</span>';
    $('#drawerCartTotalNotes').show();
  } else {
    $('#drawerCartTotalNotes').hide();
  }

  $('#drawerCartTotalText').html(text);
}


//top logo-link
/*
$(function(){
  $('#shopify-section-1625980562617c0e45 a[href="/collections/ads-japan"]').attr('href','javascript:void(0);');
});
*/

//mxpr-like-heart
$(function(){
	$('.mxpr-like-container .mxpr-like.mxpr-like-left,.mxpr-like-container .mxpr-like.mxpr-like-content,.mxpr-like-container .mxpr-like.mxpr-like-right').on('click',function(){
		$('.mxpr-like-container .mxpr-like.mxpr-like-heart')[0].click();
	});
});
